import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export function createSupabaseClient(getToken) {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('Supabase env vars (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY) not set — database features disabled')
    return null
  }
  // Use a custom fetch to explicitly set both required Supabase headers on every
  // request. supabase-js v2.97+ with the `accessToken` option does not reliably
  // forward the anon key as the `apikey` header; a custom fetch bypasses that.
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      fetch: async (url, options = {}) => {
        const clerkToken = await getToken({ template: 'supabase' })
        const headers = new Headers(options.headers)
        headers.set('apikey', supabaseAnonKey)
        if (clerkToken) headers.set('Authorization', `Bearer ${clerkToken}`)
        return fetch(url, { ...options, headers })
      }
    }
  })
}
